import { useState } from "react";
import { Minus, Plus, CheckCircle2 } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetDescription } from "./ui/sheet";
import { CollectForm } from "./CollectForm";
import { useCart } from "../lib/cart";
import { gbp } from "../lib/store";

const Line = ({ i }) => {
  const { setQty } = useCart();
  return (
    <div className="flex gap-4 border-b border-black/10 py-4" data-testid={`guna-cart-item-${i.sku}`}>
      <img src={i.image} alt={i.name} className="arch h-20 w-16 object-cover" />
      <div className="flex flex-1 flex-col justify-between">
        <div className="flex justify-between gap-2">
          <p className="font-display text-xl leading-tight text-[#1C1917]">{i.name}</p>
          <span className="font-mono-g text-sm text-[#D62828]">{gbp(i.price * i.qty)}</span>
        </div>
        <div className="flex items-center gap-3">
          <button onClick={() => setQty(i.sku, i.qty - 1)} data-testid={`guna-cart-dec-${i.sku}`} className="grid h-7 w-7 place-items-center rounded-full border border-black/20 hover:border-[#D62828]"><Minus className="h-3 w-3" /></button>
          <span className="font-mono-g text-sm">{i.qty}</span>
          <button onClick={() => setQty(i.sku, i.qty + 1)} data-testid={`guna-cart-inc-${i.sku}`} className="grid h-7 w-7 place-items-center rounded-full border border-black/20 hover:border-[#D62828]"><Plus className="h-3 w-3" /></button>
          <span className="font-mono-g ml-auto text-[11px] text-stone-600">{i.size}</span>
        </div>
      </div>
    </div>
  );
};

const Done = ({ order }) => (
  <div className="flex flex-1 flex-col items-start justify-center gap-4" data-testid="guna-order-confirmation">
    <CheckCircle2 className="h-10 w-10 text-[#D62828]" />
    <h3 className="font-display text-5xl text-[#1C1917]">See you soon, {order?.name?.split(" ")[0]}.</h3>
    <p className="text-stone-700">We'll have it bagged for <b className="text-[#1C1917]">{order?.pickup_time}</b>.</p>
    <div className="w-full rounded-2xl border border-black/10 p-5">
      <p className="font-mono-g text-xs uppercase tracking-[0.25em] text-stone-600">Your reference</p>
      <p className="font-mono-g mt-1 text-3xl text-[#D62828]" data-testid="guna-order-ref">{order?.ref}</p>
      <p className="mt-3 text-sm text-stone-700">Total to pay in store: <span className="font-mono-g">{gbp(order?.total)}</span></p>
    </div>
  </div>
);

export const CartDrawer = () => {
  const { items, total, open, setOpen } = useCart();
  const [step, setStep] = useState("basket");
  const [order, setOrder] = useState(null);
  const onOpenChange = (v) => { setOpen(v); if (!v) { setStep("basket"); setOrder(null); } };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent data-lenis-prevent data-testid="guna-cart-drawer" className="flex w-full flex-col overflow-y-auto border-black/10 bg-[#FFFFFF] p-6 text-[#1C1917] sm:max-w-md">
        <SheetTitle className="font-display text-4xl font-normal text-[#1C1917]">Collect basket</SheetTitle>
        <SheetDescription className="font-mono-g text-xs uppercase tracking-[0.2em] text-[#D62828]">No online payment · pay at the till</SheetDescription>
        {step === "done" && <Done order={order} />}
        {step !== "done" && items.length === 0 && (
          <p className="flex-1 pt-10 text-stone-700" data-testid="guna-cart-empty">Your basket is empty. Go fill it up.</p>
        )}
        {step !== "done" && items.length > 0 && (
          <>
            <div className="flex-1">{items.map((i) => <Line key={i.sku} i={i} />)}</div>
            <div className="mt-4 flex items-baseline justify-between">
              <span className="text-stone-700">Total</span>
              <span className="font-mono-g text-2xl text-[#D62828]" data-testid="guna-cart-total">{gbp(total)}</span>
            </div>
            {step === "basket" ? (
              <button onClick={() => setStep("form")} data-testid="guna-cart-checkout-button"
                className="mt-4 rounded-full bg-[#D62828] py-4 text-sm font-semibold text-[#FFFFFF]">Continue to collection</button>
            ) : (
              <div className="mt-4"><CollectForm onDone={(o) => { setOrder(o); setStep("done"); }} /></div>
            )}
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};
